var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNoBatchWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1284 7.40348L36.2431 28.4287C36.5097 29.0563 36.6263 29.5666 36.6597 30.0967C36.7263 31.3353 36.293 32.5393 35.4432 33.4658C34.5933 34.3889 33.4435 34.9339 32.1937 35H7.79785C7.28127 34.9686 6.76469 34.8514 6.28144 34.6697C3.86518 33.6953 2.69871 30.9538 3.68187 28.5773L15.8798 7.38862C16.2964 6.6438 16.9296 6.00136 17.7128 5.58849C19.9791 4.3317 22.862 5.15745 24.1284 7.40348ZM21.4455 21.2595C21.4455 22.0523 20.7957 22.7145 19.9958 22.7145C19.1959 22.7145 18.5294 22.0523 18.5294 21.2595V16.5875C18.5294 15.7931 19.1959 15.1507 19.9958 15.1507C20.7957 15.1507 21.4455 15.7931 21.4455 16.5875V21.2595ZM19.9958 28.3626C19.1959 28.3626 18.5294 27.7004 18.5294 26.9093C18.5294 26.1149 19.1959 25.4543 19.9958 25.4543C20.7957 25.4543 21.4455 26.1001 21.4455 26.8911C21.4455 27.7004 20.7957 28.3626 19.9958 28.3626Z",
    fill: "#D29822"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoBatchWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NoBatchWarning.b107ac5a.svg";
export { ForwardRef as ReactComponent };